/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationsDto } from '../../models/organizations-dto';
import { UpdateOrganizationResponse } from '../../models/update-organization-response';

export interface UpdateOrganization$Params {
  organizationId: string;
      body: OrganizationsDto
}

export function updateOrganization(http: HttpClient, rootUrl: string, params: UpdateOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOrganizationResponse>> {
  const rb = new RequestBuilder(rootUrl, updateOrganization.PATH, 'patch');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateOrganizationResponse>;
    })
  );
}

updateOrganization.PATH = '/api/v2/{organizationId}';
